/* MASA SHOP — petites améliorations progressives (sans dépendance).
   Le site reste utilisable sans ce fichier. */
(function () {
  'use strict';

  // Rails produits (mobile/tablette) : les flèches gauche/droite font défiler d'une carte.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRails(root) {
    (root || document).querySelectorAll('.masa-rail').forEach(function (rail) {
      if (rail.dataset.masaReady) return;
      rail.dataset.masaReady = 'true';
      rail.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        if (window.getComputedStyle(rail).overflowX === 'visible') return;
        var item = rail.querySelector('li');
        if (!item) return;
        event.preventDefault();
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        var step = item.getBoundingClientRect().width + gap;
        rail.scrollBy({
          left: event.key === 'ArrowRight' ? step : -step,
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      });
    });
  }

  // Fiche produit (mobile) : barre d'achat affichée quand le bouton principal a défilé hors
  // de l'écran. Elle recopie le prix et l'état du vrai bouton, et le déclenche au clic.
  function currentPrice(sectionId) {
    var price = document.querySelector('#price-' + sectionId + ' .price');
    if (!price) return '';
    var item = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular');
    return item ? item.textContent.trim() : '';
  }

  function initStickyBuy(root) {
    (root || document).querySelectorAll('[data-masa-sticky-buy]').forEach(function (bar) {
      if (bar.dataset.masaReady || !('IntersectionObserver' in window)) return;
      var sectionId = bar.dataset.section;
      var main = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!main) return;
      bar.dataset.masaReady = 'true';
      var trigger = bar.querySelector('[data-masa-sticky-trigger]');
      var priceEl = bar.querySelector('[data-masa-sticky-price]');
      var info = document.getElementById('MainProduct-' + sectionId);
      var errorBox = info ? info.querySelector('.product-form__error-message-wrapper') : null;
      var awaitingResult = false;

      function setVisible(visible) {
        bar.hidden = !visible;
        document.body.classList.toggle('masa-has-sticky-buy', visible);
        if (!visible) {
          bar.classList.remove('is-visible');
          return;
        }
        requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      }

      function sync() {
        var label = main.querySelector('span');
        trigger.textContent = label ? label.textContent.trim() : trigger.textContent;
        trigger.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
        priceEl.textContent = currentPrice(sectionId);
        // Erreur d'ajout (stock, règle de quantité) : Dawn l'affiche près du bouton principal,
        // hors écran — on l'amène sous les yeux de la personne.
        if (awaitingResult && errorBox && !errorBox.hidden) {
          awaitingResult = false;
          errorBox.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      }

      trigger.addEventListener('click', function () {
        awaitingResult = true;
        main.click();
      });

      // Zone d'observation prolongée très loin sous l'écran : « bouton plus bas que l'écran » compte
      // comme visible, « bouton passé au-dessus » comme sorti. Chaque passage est ainsi signalé, même
      // quand la page saute d'un coup (défilement rapide, retour de Dawn vers la photo d'une variante).
      var visibility = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (passed) sync();
          setVisible(passed);
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      visibility.observe(main);

      // Changement de variante ou résultat d'ajout : Dawn remplace le prix et l'état du bouton.
      var changes = null;
      if (info) {
        changes = new MutationObserver(sync);
        changes.observe(info.querySelector('.product__info-container') || info, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled', 'hidden'],
        });
      }

      bar.masaCleanup = function () {
        visibility.disconnect();
        if (changes) changes.disconnect();
        setVisible(false);
      };
    });
  }

  // Page Marques (mobile et tablette, 1 à 2 colonnes) : les lettres des groupes affichés à l'écran
  // sont repérées dans l'index A–Z. Sur ordinateur, toutes les marques tiennent à l'écran :
  // le repère n'apporterait rien.
  var fewColumns = window.matchMedia('(max-width: 989px)');

  function initBrandIndex(root) {
    (root || document).querySelectorAll('[data-masa-az-nav]').forEach(function (nav) {
      if (nav.dataset.masaReady || !('IntersectionObserver' in window)) return;
      nav.dataset.masaReady = 'true';
      var links = {};
      nav.querySelectorAll('a[href^="#brands-"]').forEach(function (link) {
        links[link.getAttribute('href').slice(1)] = link;
      });
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var link = links[entry.target.id];
          if (link) link.classList.toggle('is-visible', fewColumns.matches && entry.isIntersecting);
        });
      }, { rootMargin: '-25% 0px -25% 0px' });
      fewColumns.addEventListener('change', function () {
        if (fewColumns.matches) return;
        Object.keys(links).forEach(function (id) {
          links[id].classList.remove('is-visible');
        });
      });
      Object.keys(links).forEach(function (id) {
        var group = document.getElementById(id);
        if (group) observer.observe(group);
      });
    });
  }

  // En-tête : sa hauteur réelle (--masa-header-offset) sert au hero placé dessous. Sur l'accueil,
  // l'en-tête transparent reprend son fond dès que la page défile ou qu'un menu s'ouvre.
  var headerCleanup = null;

  function initHeader() {
    if (headerCleanup) headerCleanup(); // éditeur de thème : l'en-tête a été rechargé
    var wrapper = document.querySelector('.masa-header-wrapper');
    if (!wrapper) return;
    var root = document.documentElement;
    function measure() {
      root.style.setProperty('--masa-header-offset', wrapper.getBoundingClientRect().height + 'px');
    }
    measure();
    var resize = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (resize) resize.observe(wrapper);
    var onScroll = null;
    headerCleanup = function () {
      if (resize) resize.disconnect();
      if (onScroll) window.removeEventListener('scroll', onScroll);
      headerCleanup = null;
    };

    if (!wrapper.classList.contains('masa-header-wrapper--overlay')) return;
    var ticking = false;
    function update() {
      ticking = false;
      var open = wrapper.querySelector('details[open]') !== null;
      wrapper.classList.toggle('masa-header--solid', open || window.scrollY > 8);
    }
    onScroll = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    wrapper.addEventListener('toggle', update, true);
    wrapper.addEventListener('focusin', function () {
      wrapper.classList.add('masa-header--solid');
    });
    wrapper.addEventListener('focusout', function () {
      requestAnimationFrame(update);
    });
    update();
  }

  // Page Marques : « Chercher une marque » filtre la liste (sans accents ni casse) ; les groupes
  // de lettres sans résultat sont masqués et le nombre de marques trouvées est annoncé.
  function fold(text) {
    return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function initBrandFilter(root) {
    (root || document).querySelectorAll('[data-masa-brand-filter]').forEach(function (box) {
      if (box.dataset.masaReady) return;
      box.dataset.masaReady = 'true';
      var input = box.querySelector('input');
      var status = box.querySelector('[role="status"]');
      var scope = box.closest('.masa-brands-page') || document;
      var groups = scope.querySelectorAll('.masa-az__group');
      box.hidden = false;
      input.addEventListener('input', function () {
        var query = fold(input.value);
        var found = 0;
        groups.forEach(function (group) {
          var visible = 0;
          group.querySelectorAll('.masa-az__item').forEach(function (item) {
            var match = !query || fold(item.textContent).indexOf(query) !== -1;
            item.hidden = !match;
            if (match) visible++;
          });
          group.hidden = visible === 0;
          found += visible;
        });
        if (!query) {
          status.textContent = '';
        } else if (found === 0) {
          status.textContent = status.dataset.empty;
        } else {
          status.textContent = (found === 1 ? status.dataset.one : status.dataset.other).replace('[count]', found);
        }
      });
    });
  }

  // Menu mobile : les sous-menus en accordéon ([data-masa-accordion]) s'ouvrent vers le bas, de façon
  // native. On arrête le clic avant le script du tiroir de Dawn (panneau glissant), qui les refermait.
  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest ? event.target.closest('[data-masa-accordion] > summary') : null;
      if (summary) event.stopPropagation();
    },
    true
  );
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details.hasAttribute || !details.hasAttribute('data-masa-accordion')) return;
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    initBrandFilter();
    initHeader();
    initRails();
    initStickyBuy();
    initBrandIndex();
  });

  // Éditeur de thème : nettoie avant le remplacement d'une section, réinitialise après.
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-masa-sticky-buy]').forEach(function (bar) {
      if (bar.masaCleanup) bar.masaCleanup();
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.masa-header-wrapper')) initHeader();
    initRails(event.target);
    initStickyBuy(event.target);
    initBrandIndex(event.target);
    initBrandFilter(event.target);
  });
})();
